import { ADDRESS_FORM_IDS } from '@/components/blocks/AddressForm/constants';
import {
	AANoExteriorNumberCheckboxSX,
	AANoExteriorNumberLabelSX,
} from '@/components/blocks/AddressForm/styles/formFields';
import { useLocalization } from '@/data/Localization';
import { Checkbox, FormControlLabel, SxProps, Theme } from '@mui/material';
import { FC } from 'react';

type Props = {
	checked: boolean;
	onChange: (checked: boolean) => void;
	sx?: SxProps<Theme>;
};

export const NoExteriorNumberCheckbox: FC<Props> = ({ checked, onChange, sx }) => {
	const addressFormNLS = useLocalization('AddressForm');

	return (
		<FormControlLabel
			control={
				<Checkbox
					id={ADDRESS_FORM_IDS.noExteriorNumberCheckbox}
					size="small"
					checked={checked}
					onChange={(_event, isChecked) => onChange(isChecked)}
					sx={AANoExteriorNumberCheckboxSX}
				/>
			}
			label={addressFormNLS.Labels.NoExteriorNumber.t()}
			sx={[AANoExteriorNumberLabelSX, ...(Array.isArray(sx) ? sx : [sx])]}
		/>
	);
};
